import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { UtilsService } from 'src/app/core/services/utils.service';

@Injectable({
  providedIn: 'root'
})
export class CreditService extends BaseProvider {

  purchaseList: any = [];
  balance: any = [];
  toggleDateFormatError:boolean = false;
  getBalanceEvent = new Subject();
  getCreditPurchasesEvent = new Subject();
  
  page: any =  1;
  size: any = 10;
  constructor(

    public globals: GlobalsService,
    public http: HttpClient,
    public utils: UtilsService,

  ) {

    super();
   
    this.baseUrl = 'creditExternal';
   
  }

  getBalance() {
    return new Promise((resolve, reject) => {
      
      this.url =  this.globals.dataUrl + 
                  this.baseUrl

      this.http.get(this.url).subscribe(
        (data: any) => {

          this.balance = data.Data;
          
          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  payCreditAndSubmit(data, transactionId){
    return new Promise( (resolve, reject) => {
      this.url = this.globals.dataUrl + this.baseUrl + `/credit/payment/${transactionId}`;

        this.http
        .post(
          this.url,
          data
        )
        .subscribe(
            (data: any) => {
                resolve(data);
            },
            err => {reject(err)}
        );
    });     		
}

  getPurchases(params) {
    return new Promise((resolve, reject) => {
      
      this.url =  this.globals.dataUrl + 
                  this.baseUrl + 
                  '/page/' + params.pageNumber +
					        '/size/' + params.pageSize;

      this.http.get(this.url).subscribe(
        (data: any) => {

          this.purchaseList = data.Data;

          resolve(data.Data);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

  pay(data){
    return new Promise((resolve, reject) => {
      this.url =  this.globals.dataUrl + this.baseUrl;
      this.http
	        .post(
	          this.url,
	          data
	        )
	        .subscribe(
	            (data: any) => {
	                resolve(data);
	            },
	            err => {reject(err)}
	        );
    });
  }
  

}
